import { Dispatch } from 'react-redux';
import { PlainRoute } from 'react-router';
import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { requestCloseLeftSideMenu } from '../MenuManager/actions';
import { SharePanelActionKeys } from '../Share/actions';
import { RoutePath } from '../../routes/constants';
import StatsUtils from '../../utils/statistics';

export enum RouteParamsActionKeys {
	SET_ROUTE_PARAMS = '@@routeParams/SET_ROUTE_PARAMS'
}

export interface SetRouteParamsAction extends Action {
	type: RouteParamsActionKeys.SET_ROUTE_PARAMS;
	data: {};
	routes: PlainRoute[];
}

export const setRouteParams = (data: {}, routes: PlainRoute[]) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const currentPath = routes[routes.length - 1].path as RoutePath;
	const { isOpen } = getState().sharePanel;

	if (currentPath) {
		StatsUtils.trackPageView(currentPath, data);
	}

	if (isOpen) {
		dispatch({ type: SharePanelActionKeys.CLOSE_PANEL });
	}

	dispatch(requestCloseLeftSideMenu());
	dispatch({ type: RouteParamsActionKeys.SET_ROUTE_PARAMS, data, routes });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SetRouteParams/actions.ts